import MyDialog from "~/mui/MyDialog";
import { myUseState } from "~/hooks/myUseState";
import { deferPromise } from "~/utils/utils";
import { useNonHookTrans } from '~/hooks/useTrans';

import "./style.less";

interface IState {
	dialogLoading: boolean;
	errorMsg: string;
}

interface IRemoveDialog {
	title: string;
	desc: string;
	cancelCaption?: string;
	removeCaption?: string;
	onClose?: () => void;
	onRemove?: (resolve: () => void, reject: (error: string) => void) => void;
}

export default function RemoveDialog({
	title = "",
	desc = "",
	cancelCaption = useNonHookTrans().trans("cancel"),
	removeCaption = useNonHookTrans().trans("delete"),
	onClose = () => {},
	onRemove = () => {},
}: IRemoveDialog) {
	const { state, updateState } = myUseState<IState>({
		dialogLoading: false,
		errorMsg: "",
	});

	async function dialogOnSave() {
		updateState({
			dialogLoading: true,
			errorMsg: "",
		});

		const promiseData = deferPromise();

		// signal
		onRemove(promiseData.resolveCb, promiseData.rejectCb);

		const promiseOutputData = await promiseData.promise;

		if (promiseOutputData.error) {
			updateState({
				dialogLoading: false,
				errorMsg: promiseOutputData.error,
			});
		} else {
			onClose();
		}
	}

	return <MyDialog title={title} onClose={onClose} onSave={dialogOnSave} dialogLoading={state.dialogLoading} errorMsg={state.errorMsg}
		cancelCaption={cancelCaption} saveCaption={removeCaption} contentClassName="removeDialog__content">
		<p>
			{ desc }
		</p>
	</MyDialog>;
}
